import { mainnet, arbitrum, katana } from "viem/chains";

export interface NetworkConfig {
    chainId: number;
    name: string;
    rpcUrl: string;
    blockExplorerUrl: string;
    isTestnet: boolean;
    logo: string;
}

export const NETWORK_CONFIG: Record<number, NetworkConfig> = {
    [mainnet.id]: {
        chainId: mainnet.id,
        name: "Ethereum Mainnet",
        rpcUrl: "https://eth-mainnet.g.alchemy.com/v2/K_QY1bNgSWqQLkwJmJb8spSjZ8pcqIAW",
        blockExplorerUrl: "https://etherscan.io",
        isTestnet: false,
        logo: "/asset/chains/ethereum.png",
    },
    [arbitrum.id]: {
        chainId: arbitrum.id,
        name: "Arbitrum",
        rpcUrl: "https://arb-mainnet.g.alchemy.com/v2/K_QY1bNgSWqQLkwJmJb8spSjZ8pcqIAW",
        blockExplorerUrl: "https://arbiscan.io",
        isTestnet: false,
        logo: "/asset/chains/arbitrum.png",
    },
    [katana.id]: {
        chainId: katana.id,
        name: "Katana",
        rpcUrl: "https://katana.drpc.org",
        blockExplorerUrl: "https://katanascan.com/",
        isTestnet: true,
        logo: "/asset/chains/katana.png",
    },
} as const;

export const SUPPORTED_CHAIN_IDS = Object.keys(NETWORK_CONFIG).map(Number);

export const DEFAULT_CHAIN_ID = mainnet.id;
